const appInsights: { default: string; trackPageView: Function; flush: Function; trackException: Function; context: { telemetryTrace: { traceID: string } } } | null = null;

export default appInsights;
